import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";

const useStyles = createUseStyles((theme) => ({
	root: {},
	mobileBigView: {},
	value: {
		fontSize: "23px",
		// lineHeight: 1.24,
		fontFamily: theme.fonts.bold,
		color: theme.palette.colors.darkSlateBlue,
	},
	noValue: {},
	main: {
		display: "flex",
		alignItems: "flex-end",
		justifyContent: "center",
	},
	valueInfinity: {
		fontSize: "23px",
		// lineHeight: 1.24,
		color: theme.palette.colors.darkSlateBlue,
	},
	measure: {
		fontSize: "14px",
		// lineHeight: 1.42,
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.darkSlateBlue,
		marginLeft: "4px",
	},
	comments: {
		marginTop: "12px",
	},
	comment: {
		fontSize: "12px",
		fontFamily: theme.fonts.medium,
		color: theme.palette.colors.oneMoreGrey,
		lineHeight: 1.42,
		margin: "0 0 12px 0",
		padding: 0,
		textAlign: "center",
		"&:last-child": {
			marginBottom: 0,
		},
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		value: {
			fontSize: "18px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		value: {
			fontSize: "16px",
		},
		valueInfinity: {
			fontSize: "16px",
		},
		measure: {
			fontSize: "12px",
			marginLeft: "4px",
		},
		comments: {
			marginTop: "6px",
		},
		comment: {
			margin: "0 0 6px 0",
		},
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		main: {
			height: "25px",
		},
		value: {
			fontSize: "18px",
		},
		noValue: {
			fontSize: "20px",
		},
		measure: {
			fontSize: "14px",
		},
		comments: {
			marginTop: "3px",
		},
		comment: {
			textAlign: "left",
			margin: "0 0 3px 0",
		},
		mobileBigView: {
			"& $value": {
				fontSize: "23px",
			},
		},
	},
}));

const SmsComponent = ({ mobileBigView, value, type, measure, comments }) => {
	const classes = useStyles();

	return (
		<div
			className={classNames(classes.root, {
				[classes.mobileBigView]: mobileBigView,
			})}
		>
			<div className={classes.main}>
				{type == 1 && (
					<span className={classNames("icon24 icon-infinite", classes.valueInfinity)} />
				)}
				{type != 1 && (
					<span
						className={classNames(classes.value, {
							[classes.noValue]: !value,
						})}
					>
						{!!value ? value : "-"}
					</span>
				)}
				{!!measure && <span className={classes.measure}>{measure}</span>}
			</div>
			{!!comments && (
				<div className={classes.comments}>
					{comments.map((comment, index) => {
						return (
							<p className={classes.comment} key={index}>
								{comment}
							</p>
						);
					})}
				</div>
			)}
		</div>
	);
};

export default SmsComponent;
